import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormContext } from "react-hook-form";
import queryString from 'query-string';

import { CampaignType, TARGET_CUSTOMER_TYPE } from "config/CustomEnums";
import { useHistory } from "react-router-dom";

const PrefillSettingBySearch = () => {
  const dispatch = useDispatch()
  const history = useHistory();
  const {
    getValues,
    watch,
    setValue,
  } = useFormContext();
  const search = queryString.parse(history.location.search);

  const earningRuleField = 'linkedEarningRules';
  const couponField = 'linkedCoupon';
  const campaignTypeField = 'campaignType';
  const watchCampaignType = watch(campaignTypeField);

  const fetchLinked = ({ actionName, idKey, idValue, dataKey }) => {
    dispatch({
      type: actionName,
      payload: {
        [idKey]: idValue,
        afterAction: (data) => {
          console.log('@@111: ', data);
          const sourceTranslations = { ...getValues().translations };
          (Object.keys(data[dataKey]?.translations) || []).forEach((lang) => {
            const translation = data[dataKey]?.translations[lang];

            (Object.keys(translation) || []).forEach((key) => {
              if (sourceTranslations[lang] && key in sourceTranslations[lang]) {
                setValue(`translations.${lang}.${key}`, translation[key], {
                  shouldDirty: true,
                });
              } else if (
                !sourceTranslations[lang] &&
                ['id', 'pk'].indexOf(key) < 0
              ) {
                setValue(`translations.${lang}.${key}`, translation[key], {
                  shouldDirty: true,
                });
              }
            });
          });
        },
      },
    });
  };


  const linkCouponChanged = (coupon) => {
    if (coupon?.pk) {
      fetchLinked({
        actionName: 'createCampaign/getAndLinkCouponDetail',
        idKey: 'couponId',
        idValue: coupon.pk,
        dataKey: couponField,
      });
    }
  };

  const linkEarningRuleChanged = (earningRule) => {
    if (earningRule?.pk) {
      fetchLinked({
        actionName: 'createCampaign/getAndLinkEarningRuleDetail',
        idKey: 'earningRuleId',
        idValue: earningRule.pk,
        dataKey: earningRuleField,
      });
    }
  };

  const prefillEarningRuleSettingToGMCampaign = ({
    earningRule,
    campaignType,
  }) => {
    if (campaignType !== CampaignType.generalMessageCampaign) {
      return;
    }

    if (earningRule?.startDate && !earningRule?.endDate) {
      setValue('isAlwaysActivePeriod', true, { shouldDirty: true });
    }
    earningRule?.startDate &&
      setValue('activeStartDate', new Date(earningRule?.startDate), {
        shouldDirty: true,
      });
    earningRule?.endDate &&
      setValue('activeEndDate', new Date(earningRule?.endDate), {
        shouldDirty: true,
      });

    if (!earningRule?.isExclusive) {
      return
    }
    setValue('isExclusive', true, { shouldDirty: true });
    const earningRuleTargetType = earningRule?.targetType;
    const selectedSegment = earningRule?.targetedSegments?.edges?.map(
      (item) => item.node
    ) || [];
    const selectedLevels = earningRule?.targetedLevels?.edges?.map(
      (item) => item.node,
    ) || [];
    let generalType = TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT;

    if (earningRuleTargetType === TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT) {
      generalType = TARGET_CUSTOMER_TYPE.DYNAMIC_SEGMENT
      setValue('dynamicSegments', selectedSegment, { shouldDirty: true });
    } else if (earningRuleTargetType === TARGET_CUSTOMER_TYPE.STATIC_SEGMENT) {
      generalType = TARGET_CUSTOMER_TYPE.STATIC_SEGMENT
      setValue('staticSegments', selectedSegment, { shouldDirty: true });
    } else if (earningRuleTargetType === TARGET_CUSTOMER_TYPE.LEVEL) {
      generalType = TARGET_CUSTOMER_TYPE.LEVEL
      setValue('levels', selectedLevels, { shouldDirty: true });
    }
    setValue('generalType', generalType, { shouldDirty: true });
  };

  useEffect(() => {
    if (history.location.search && !watchCampaignType) {
      const { type, id } = search
      if (!id) {
        return;
      }
      const actionName =
        type === CampaignType.couponsCampaign
          ? 'getAndLinkCouponDetail'
          : 'getAndLinkEarningRuleDetail';
      dispatch({
        type: `createCampaign/${actionName}`,
        payload: {
          couponId: id,
          earningRuleId: id,
          afterAction: (data) => {
            console.log('@93', data);
            setValue(campaignTypeField, type);
            if (data.linkedCoupon) {
              const coupon = data.linkedCoupon;
              setValue(couponField, coupon);
              linkCouponChanged(coupon);
            } else {
              prefillEarningRuleSettingToGMCampaign({
                earningRule: data.linkedEarningRules,
                campaignType: type,
              });
              const earningRule = data.linkedEarningRules;
              if (type === CampaignType.earningRulesCampaign) {
                setValue(earningRuleField, earningRule);
              };
              linkEarningRuleChanged(earningRule);
            }
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>
}

export default PrefillSettingBySearch;